import api from "./api";

export default {
  mixins: [ api ],
  methods: {
    // Получение списка персонала
    async getStaffs(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);

      if (data.organization_id) {
        params.set("organization_id", data.organization_id);
      }

      if (data.department_id) {
        params.set("department_id", data.department_id);
      }

      if (data.job_title_id) {
        params.set("job_title_id", data.job_title_id);
      }

      return await this.get(`staffs?${params.toString()}${sorting}`);
    },
    // Получение персонала по id
    async getStaffById(id) {
      return await this.get(`staffs/${id}`);
    },
    // Создание персонала
    async postStaff(data) {
      return await this.post('staffs', data);
    },
    // Изменение персонала
    async putStaff(data) {
      return await this.put(`staffs/${data.id}`, data);
    },
    // Получение персонала по запросу
    async getStaffsSearch(query = '') {
      const params = new URLSearchParams();
      params.set('page', '1');
      params.set('size', '400');

      if (query) {
        params.set('query', query);
      }

      return await this.get(`staffs/search?${params.toString()}`);
    },
  }
}



// WEBPACK FOOTER //
// ./src/network/staff.js